export const HamburgerMenu = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 10H17.5"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5H17.5"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 15H17.5"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40387 18C1.89875 18 1.47119 17.825 1.12119 17.475C0.771191 17.125 0.596191 16.6974 0.596191 16.1923V2.3077C0.596191 1.80257 0.771191 1.375 1.12119 1.025C1.47119 0.675 1.89875 0.5 2.40387 0.5H9.11539V1.99997H2.40387C2.32693 1.99997 2.25642 2.03202 2.19232 2.09613C2.1282 2.16024 2.09614 2.23077 2.09614 2.3077V16.1923C2.09614 16.2692 2.1282 16.3398 2.19232 16.4039C2.25642 16.468 2.32693 16.5 2.40387 16.5H9.11539V18H2.40387ZM13.1346 13.5192L12.0962 12.4346L14.5308 9.99998H6.11539V8.5H14.5308L12.0962 6.0654L13.1346 4.98082L17.4038 9.25L13.1346 13.5192Z"
        fill="#121212"
      />
    </svg>
  );
};
export const QuestionMarkIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1401 11.505V11.1125C10.1401 9.82976 10.933 9.13423 11.7275 8.60041C12.5031 8.07758 13.2802 7.39617 13.2802 6.14012C13.2802 4.4052 11.875 3 10.1401 3C8.4052 3 7 4.4052 7 6.14012"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1389 15.8222C9.92227 15.8222 9.74642 15.998 9.74799 16.2147C9.74799 16.4314 9.92384 16.6072 10.1405 16.6072C10.3572 16.6072 10.533 16.4314 10.533 16.2147C10.533 15.998 10.3572 15.8222 10.1389 15.8222"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchOutline = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7.84394"
        cy="7.84394"
        r="5.99237"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0117 12.3242L14.3611 14.6675"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PlusFill = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3623 8.27148H3.3623"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3623 13.2715V3.27148"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotificationOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10516 13.428V13.2529C5.13122 12.7346 5.29968 12.2325 5.59315 11.7983C6.08164 11.2767 6.41604 10.6375 6.56126 9.94773C6.56126 9.41464 6.56126 8.87394 6.60848 8.34085C6.85248 5.77442 9.42623 4 11.9685 4H12.0315C14.5737 4 17.1475 5.77442 17.3993 8.34085C17.4466 8.87394 17.3993 9.41464 17.4387 9.94773C17.5859 10.6391 17.9199 11.2803 18.4068 11.8059C18.7025 12.2363 18.8712 12.7366 18.8948 13.2529V13.4204C18.9124 14.1166 18.6692 14.7955 18.21 15.3319C17.6033 15.9591 16.78 16.3492 15.896 16.4285C13.3038 16.7027 10.6883 16.7027 8.09606 16.4285C7.21304 16.3458 6.39093 15.9562 5.78205 15.3319C5.33002 14.7951 5.09008 14.1203 5.10516 13.428Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0176 19.0815C10.4226 19.5828 11.0174 19.9072 11.6703 19.9829C12.3232 20.0587 12.9804 19.8796 13.4965 19.4852C13.6552 19.3685 13.798 19.2329 13.9215 19.0815"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SettingsOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1213 9.87868C15.2929 11.0502 15.2929 12.9497 14.1213 14.1213C12.9497 15.2929 11.0502 15.2929 9.87868 14.1213C8.70711 12.9497 8.70711 11.0502 9.87868 9.87868C11.0502 8.70711 12.9497 8.70711 14.1213 9.87868"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.18 18.725V18.725C16.683 19.228 17.5 19.228 18.003 18.725L18.725 18.003C19.228 17.5 19.228 16.683 18.725 16.18V16.18C18.343 15.798 18.231 15.225 18.441 14.727C18.463 14.674 18.485 14.621 18.506 14.567C18.689 14.101 19.143 13.801 19.643 13.801H19.71C20.422 13.801 20.999 13.224 20.999 12.512V11.491C20.999 10.779 20.422 10.202 19.71 10.202H19.643C19.143 10.202 18.689 9.901 18.506 9.436C18.485 9.382 18.463 9.329 18.441 9.276C18.231 8.778 18.343 8.205 18.725 7.823V7.823C19.228 7.32 19.228 6.503 18.725 6L18.003 5.278C17.5 4.775 16.683 4.775 16.18 5.278V5.278C15.798 5.66 15.225 5.772 14.727 5.562C14.674 5.54 14.621 5.518 14.567 5.497C14.101 5.311 13.8 4.856 13.8 4.356V4.289C13.8 3.577 13.223 3 12.511 3H11.49C10.777 3 10.2 3.577 10.2 4.289V4.356C10.2 4.856 9.899 5.31 9.434 5.493C9.38 5.515 9.327 5.536 9.274 5.559C8.776 5.769 8.203 5.657 7.821 5.275V5.275C7.318 4.772 6.501 4.772 5.998 5.275L5.275 5.997C4.772 6.5 4.772 7.317 5.275 7.82V7.82C5.657 8.202 5.769 8.775 5.559 9.273C5.536 9.327 5.515 9.38 5.494 9.434C5.311 9.899 4.856 10.2 4.356 10.2H4.289C3.577 10.2 3 10.777 3 11.489V12.51C3 13.223 3.577 13.8 4.289 13.8H4.356C4.856 13.8 5.31 14.101 5.493 14.566C5.514 14.62 5.536 14.673 5.558 14.726C5.768 15.224 5.656 15.797 5.274 16.179V16.179C4.771 16.682 4.771 17.499 5.274 18.002L5.996 18.724C6.499 19.227 7.316 19.227 7.819 18.724V18.724C8.201 18.342 8.774 18.23 9.272 18.44C9.325 18.462 9.378 18.484 9.432 18.505C9.898 18.688 10.198 19.142 10.198 19.642V19.709C10.198 20.421 10.775 20.998 11.487 20.998H12.508C13.22 20.998 13.797 20.421 13.797 19.709V19.642C13.797 19.142 14.098 18.688 14.563 18.505C14.617 18.484 14.67 18.462 14.723 18.44C15.224 18.231 15.797 18.343 16.18 18.725V18.725Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AccountOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 20.0016C5 17.5016 7 15.6016 9.4 15.6016H14.5C17 15.6016 18.9 17.6016 18.9 20.0016"
        stroke="#121212"
        strokeWidth="1.4824"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9995 5.2C16.6995 6.9 16.6995 9.6 14.9995 11.2C13.2995 12.8 10.5995 12.9 8.9995 11.2C7.3995 9.5 7.2995 6.8 8.9995 5.2C10.6995 3.6 13.2995 3.6 14.9995 5.2"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewsOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.99923H15.0013"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6.99801H15.0013"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5.99756"
        y="6.99805"
        width="3.00125"
        height="3.00125"
        rx="0.5"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99756 13.5007H15.0013"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0013 17.0022H5.99756"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0028 7.99842H19.0032C20.1083 7.99842 21.0041 8.89423 21.0041 9.99925V19.003C21.0041 20.108 20.1083 21.0038 19.0032 21.0038H4.99742C3.89239 21.0038 2.99658 20.108 2.99658 19.003V4.99717C2.99658 3.89214 3.89239 2.99634 4.99742 2.99634H16.002C17.107 2.99634 18.0028 3.89214 18.0028 4.99717V21.0038"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DropdownIcon = ({ color = "#121212" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10L12 14L16 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ModalClose = () => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9349 17.75L7.94434 7.25M18.9349 7.25L7.94434 17.75"
        stroke="#2C2C2C"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SuccessIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_228_30917)">
        <path
          d="M8 0C3.58862 0 0 3.58862 0 8C0 12.4114 3.58862 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58862 12.4114 0 8 0ZM12.0547 6.30469L7.72131 10.6379C7.59131 10.7679 7.42065 10.8334 7.25 10.8334C7.07935 10.8334 6.90869 10.7679 6.77869 10.6379L4.61206 8.47131C4.35132 8.21069 4.35132 7.78931 4.61206 7.52869C4.87268 7.26794 5.29395 7.26794 5.55469 7.52869L7.25 9.224L11.1121 5.36206C11.3727 5.10132 11.7939 5.10132 12.0547 5.36206C12.3153 5.62268 12.3153 6.04395 12.0547 6.30469Z"
          fill="#109E10"
        />
      </g>
      <defs>
        <clipPath id="clip0_228_30917">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const WarningIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9"
        r="8"
        stroke="#D41F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.11035 12.1106H10.1631"
        stroke="#D41F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.14136 12.112V8.33423H8.11914"
        stroke="#D41F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08854 5.66429C9.08854 5.78702 8.98905 5.88652 8.86632 5.88652C8.74359 5.88652 8.6441 5.78702 8.6441 5.66429C8.6441 5.54156 8.74359 5.44207 8.86632 5.44207"
        stroke="#D41F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86654 5.44234C8.98927 5.44234 9.08876 5.54183 9.08876 5.66456"
        stroke="#D41F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TreeClose = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#F1F4F8" stroke="#D0D5E0" />
      <path
        d="M10.0002 5.00391C10.1101 5.00391 10.22 5.04588 10.3038 5.12964L12.941 7.7668C13.1087 7.93456 13.1087 8.20655 12.941 8.37423C12.7733 8.54192 12.5013 8.54192 12.3336 8.37423L10.0002 6.04073L7.66681 8.37415C7.49905 8.54184 7.22714 8.54184 7.05947 8.37415C6.89163 8.20646 6.89163 7.93448 7.05947 7.76672L9.69656 5.12956C9.78041 5.04578 9.89031 5.00391 10.0002 5.00391Z"
        fill="#363A44"
      />
      <path
        d="M9.99969 14.9961C9.88977 14.9961 9.77986 14.9541 9.69606 14.8704L7.05892 12.2332C6.89117 12.0654 6.89117 11.7935 7.05892 11.6258C7.22661 11.4581 7.49854 11.4581 7.66631 11.6258L9.99969 13.9593L12.3331 11.6258C12.5008 11.4582 12.7727 11.4582 12.9404 11.6258C13.1082 11.7935 13.1082 12.0655 12.9404 12.2333L10.3033 14.8704C10.2195 14.9542 10.1096 14.9961 9.99969 14.9961Z"
        fill="#363A44"
      />
    </svg>
  );
};
export const TreeOpen = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10.1055" r="9.5" fill="#F1F4F8" stroke="#D0D5E0" />
      <path
        d="M10.0002 9.10547C9.89026 9.10547 9.78035 9.0635 9.69655 8.97974L7.05941 6.34257C6.89165 6.17482 6.89165 5.90283 7.05941 5.73514C7.2271 5.56745 7.49903 5.56745 7.6668 5.73514L10.0002 8.06865L12.3336 5.73522C12.5013 5.56753 12.7732 5.56753 12.9409 5.73522C13.1087 5.90291 13.1087 6.1749 12.9409 6.34266L10.3038 8.97982C10.22 9.06359 10.1101 9.10547 10.0002 9.10547Z"
        fill="#363A44"
      />
      <path
        d="M9.99983 11.1055C10.1097 11.1055 10.2197 11.1474 10.3035 11.2312L12.9406 13.8684C13.1083 14.0361 13.1083 14.3081 12.9406 14.4758C12.7729 14.6435 12.501 14.6435 12.3332 14.4758L9.99983 12.1423L7.66644 14.4757C7.49868 14.6434 7.22678 14.6434 7.0591 14.4757C6.89126 14.308 6.89126 14.036 7.0591 13.8683L9.6962 11.2311C9.78004 11.1473 9.88995 11.1055 9.99983 11.1055Z"
        fill="#363A44"
      />
    </svg>
  );
};
export const ProfileCam = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_348_3240)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5904 1.72803C11.2404 1.72803 11.7904 2.12803 11.9904 2.77803L12.3404 3.72803H13.1904C14.8404 3.72803 16.1904 5.07803 16.1904 6.72803V12.728C16.1904 14.378 14.8404 15.728 13.1904 15.728H3.19043C1.54043 15.728 0.19043 14.378 0.19043 12.728V6.72803C0.19043 5.07803 1.54043 3.72803 3.19043 3.72803H4.04043L4.39043 2.77803C4.54043 2.12803 5.14043 1.72803 5.79043 1.72803H10.5904ZM8.19043 5.72803C6.24043 5.72803 4.69043 7.27803 4.69043 9.22803C4.69043 11.178 6.24043 12.728 8.19043 12.728C10.1404 12.728 11.6904 11.178 11.6904 9.22803C11.6904 7.27803 10.1404 5.72803 8.19043 5.72803ZM8.19043 6.72803C9.59043 6.72803 10.6904 7.82803 10.6904 9.22803C10.6904 10.628 9.59043 11.728 8.19043 11.728C6.79043 11.728 5.69043 10.628 5.69043 9.22803C5.69043 7.82803 6.79043 6.72803 8.19043 6.72803Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_348_3240">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.19043 0.727783)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FileUploadIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2643 10.5761L11.5167 7.82861C11.2665 7.57837 10.8614 7.57837 10.6118 7.82861L7.86426 10.5761"
        stroke="#626262"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3441 13.7761H4.66414C3.60366 13.7761 2.74414 12.9166 2.74414 11.8561V4.1761C2.74414 3.11562 3.60366 2.2561 4.66414 2.2561H12.3441C13.4046 2.2561 14.2641 3.11562 14.2641 4.1761V11.8561C14.2641 12.9166 13.4046 13.7761 12.3441 13.7761Z"
        stroke="#626262"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0639 13.7761L7.03634 9.74859C6.7861 9.49835 6.38098 9.49835 6.13138 9.74859L3.0293 12.8507"
        stroke="#626262"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75435 5.92642C6.84808 6.02014 6.84808 6.1721 6.75435 6.26583C6.66063 6.35956 6.50867 6.35956 6.41494 6.26583C6.32122 6.1721 6.32122 6.02014 6.41494 5.92642C6.50867 5.83269 6.66063 5.83269 6.75435 5.92642"
        stroke="#626262"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5039 4.82715V13.3271C12.5039 14.1558 11.8192 14.8271 10.9912 14.8271H5.99124C5.16257 14.8271 4.50391 14.1558 4.50391 13.3271V4.82715"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5039 4.82717H3.50391"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.1709 2.82717H9.83756"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83724 7.49384V12.1605"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.17025 12.1605V7.49384"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TagCloseIcon = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.04263 1.60156L2.10254 6.39656"
        stroke="#040919"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.04382 6.4001L2.09961 1.6001"
        stroke="#040919"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SelectDropdown = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 6L8.5 10L4.5 6"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AddIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5039 8.82666H3.50391"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50391 13.8267V3.82666"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BoldIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83331 5H10.7291C12.1099 5 13.2291 6.11929 13.2291 7.5V7.5C13.2291 8.88071 12.1099 10 10.7291 10H5.83331V5Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83331 10H11.6666C13.0474 10 14.1666 11.1193 14.1666 12.5V12.5C14.1666 13.8807 13.0474 15 11.6666 15H5.83331V10Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ItalicIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 5L8.75 15"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6666 15.0007H5.83325"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33325 5.00065H14.1666"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UnderlineIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 5V10C13.3334 11.8409 11.841 13.3333 10 13.3333V13.3333C8.15907 13.3333 6.66669 11.8409 6.66669 10V5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83325 15.8327H14.1666"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const StrikeThroughIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66669 15H11.6667C13.0474 15 14.1667 13.8807 14.1667 12.5V12.5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8334 10.0007H4.16675"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 5H9.16669C7.78598 5 6.66669 6.11929 6.66669 7.5V7.5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CaseChangeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16626 4.99887H17.5031"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3347 15.0023V4.99817"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.77231 15.0015V8.33203"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.91376 8.33286H8.74952"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UnOrderListIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.16667H16.6667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4.99998"
        cy="4.16667"
        r="1.66667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.0007H16.6667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.8327H16.6667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4.99992"
        cy="10.0007"
        r="1.66667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4.99992"
        cy="15.8327"
        r="1.66667"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AlignLeftIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6695 3.33078H3.33057"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6695 6.66489H3.33057"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6695 10.0008H3.33057"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6695 13.3349H3.33057"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16.6688H3.33057"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GalleryIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.3335"
        y="3.33398"
        width="13.3333"
        height="13.3333"
        rx="3.7037"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0151 12.0689L13.2126 8.82974C13.5258 8.51254 13.953 8.33398 14.3987 8.33398C14.8444 8.33398 15.2716 8.51254 15.5848 8.82974L16.6668 9.92568"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7085 14.5777L6.91683 11.3277C7.22954 11.0118 7.65562 10.834 8.10016 10.834C8.54471 10.834 8.97079 11.0118 9.2835 11.3277L14.3085 16.4194"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LinkIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5375 10.6483L16.4817 8.70416C17.9134 7.2725 17.9134 4.95083 16.4817 3.51833V3.51833C15.05 2.08666 12.7284 2.08666 11.2959 3.51833L9.35168 5.4625"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40833 12.5917L12.5917 7.40833"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4625 9.35168L3.51833 11.2959C2.08666 12.7275 2.08666 15.0492 3.51833 16.4817V16.4817C4.95 17.9134 7.27166 17.9134 8.70416 16.4817L10.6483 14.5375"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DatePickerNext = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3431 17.6065C10.7337 17.997 11.3668 17.997 11.7574 17.6065L16.7071 12.6568C17.0976 12.2662 17.0976 11.6331 16.7071 11.2426L11.7574 6.29281C11.3668 5.90229 10.7337 5.90229 10.3431 6.29281C9.95262 6.68334 9.95262 7.3165 10.3431 7.70703L14.5858 11.9497L10.3431 16.1923C9.95262 16.5828 9.95262 17.216 10.3431 17.6065Z"
        fill="#121212"
      />
    </svg>
  );
};
export const DatePickerPreview = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6569 6.29289C14.2663 5.90237 13.6332 5.90237 13.2426 6.29289L8.29289 11.2426C7.90237 11.6332 7.90237 12.2663 8.29289 12.6569L13.2426 17.6066C13.6332 17.9971 14.2663 17.9971 14.6569 17.6066C15.0474 17.2161 15.0474 16.5829 14.6569 16.1924L10.4142 11.9497L14.6569 7.70711C15.0474 7.31658 15.0474 6.68342 14.6569 6.29289Z"
        fill="#121212"
      />
    </svg>
  );
};
export const DatePickerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49949 1.99731V3.99815"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5014 1.99731V3.99815"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49805 6.3325H14.503"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.49805"
        y="2.9978"
        width="12.005"
        height="11.0046"
        rx="2"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.3312 5.33203H2.66426C2.29592 5.33203 1.99731 5.63063 1.99731 5.99898V13.3354C1.99731 13.7037 2.29592 14.0023 2.66426 14.0023H10.0006C10.369 14.0023 10.6676 13.7037 10.6676 13.3354V12.6684"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5.33203"
        y="1.99731"
        width="8.67028"
        height="8.67028"
        rx="1"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83341 4.89518C4.83341 3.14918 6.25408 1.72852 8.00008 1.72852C9.74608 1.72852 11.1667 3.14918 11.1667 4.89518C11.1667 6.64118 9.74608 8.06185 8.00008 8.06185C6.25408 8.06185 4.83341 6.64118 4.83341 4.89518ZM10.0001 9.06185H6.00008C3.88675 9.06185 2.16675 10.7818 2.16675 12.8952C2.16675 13.9065 2.98875 14.7285 4.00008 14.7285H12.0001C13.0114 14.7285 13.8334 13.9065 13.8334 12.8952C13.8334 10.7818 12.1134 9.06185 10.0001 9.06185Z"
        fill="#121212"
      />
    </svg>
  );
};

export const TimePickerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.70461 2.45822C8.76527 1.19022 12.2739 2.64422 13.5419 5.70488C14.8099 8.76555 13.3559 12.2742 10.2953 13.5422C7.23461 14.8102 3.72594 13.3562 2.45794 10.2956C1.19061 7.23488 2.64394 3.72622 5.70461 2.45822"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.81152 5.32373V8.4244L10.2489 9.9104"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaginationPrev = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12L6 8L10 4"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PaginationNext = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12L10 8L6 4"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PaginationEllipsis = () => {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.58 2V0.518H2.062V2H0.58ZM4.22453 2V0.518H5.70653V2H4.22453ZM7.86906 2V0.518H9.35106V2H7.86906Z"
        fill="#121212"
      />
    </svg>
  );
};

export const TableDatePicker = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99996 2.5V3.83333"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66671 2.5V3.83333"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.50002H12.6667"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 7.16669V5.16669C12.6667 4.06202 11.7713 3.16669 10.6667 3.16669H4C2.89533 3.16669 2 4.06202 2 5.16669V11.1667C2 12.2714 2.89533 13.1667 4 13.1667H6.66667"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5953 11.1553V12.3273L12.5167 12.8893"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6666 15.1667C10.01 15.1667 8.66663 13.824 8.66663 12.1667C8.66663 10.544 10.0466 9.16469 11.6693 9.16669C13.3253 9.16802 14.6666 10.5107 14.6666 12.1667C14.6666 13.8234 13.324 15.1667 11.6666 15.1667"
        stroke="#121212"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const BackArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12H19"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7L5 12"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17L5 12"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InfoWarningIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6.99859"
        cy="6.99859"
        r="6.0025"
        stroke="#626262"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33203 9.33347H7.87223"
        stroke="#626262"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.10488 9.33451V6.5H6.33789"
        stroke="#626262"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.06466 4.49558C7.06466 4.58767 6.99001 4.66232 6.89793 4.66232C6.80584 4.66232 6.73119 4.58767 6.73119 4.49558C6.73119 4.4035 6.80584 4.32885 6.89793 4.32885"
        stroke="#626262"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89854 4.32823C6.99063 4.32823 7.06528 4.40288 7.06528 4.49497"
        stroke="#626262"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M3.52883 10.9127L10.4128 4.02874C10.6728 3.76874 11.0948 3.76874 11.3548 4.02874L12.4722 5.14607C12.7322 5.40607 12.7322 5.82807 12.4722 6.08807L5.5875 12.9714C5.46283 13.0967 5.2935 13.1667 5.11683 13.1667H3.3335V11.3834C3.3335 11.2067 3.4035 11.0374 3.52883 10.9127Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1665 5.27344L11.2265 7.33344"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TopNewsIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1308_4993)">
        <path
          d="M11.9599 5.55597L11.9599 5.55598C12.0556 5.74352 12.0381 5.96889 11.9145 6.13935C11.9145 6.13935 11.9145 6.13935 11.9144 6.13936L5.35198 15.1901C5.18788 15.4164 4.88117 15.4877 4.63371 15.3549C4.38675 15.2224 4.27569 14.9278 4.37375 14.6653C4.37375 14.6653 4.37375 14.6653 4.37376 14.6653L6.5523 8.83162H4.89848C4.7261 8.83162 4.56331 8.75226 4.45714 8.6164L4.45714 8.6164C4.35101 8.48058 4.31329 8.30344 4.35493 8.13614L4.35493 8.13613L5.99555 1.54631L11.9599 5.55597ZM11.9599 5.55597C11.8643 5.36844 11.6715 5.25035 11.461 5.25035M11.9599 5.55597L11.461 5.25035M11.461 5.25035H9.98601M11.461 5.25035H9.98601M9.98601 5.25035L11.9421 1.96842C11.9421 1.96841 11.9421 1.96841 11.9421 1.96841C12.0453 1.79531 12.0475 1.58013 11.948 1.40492C11.8485 1.22968 11.6625 1.12148 11.461 1.12148H6.53913C6.28187 1.12148 6.0577 1.2967 5.99555 1.54631L9.98601 5.25035ZM7.88419 8.46744C7.88419 8.46745 7.88418 8.46746 7.88418 8.46747L6.8663 11.1931L10.363 6.37066H9.00008C8.7986 6.37066 8.61259 6.26246 8.51305 6.08723L7.88419 8.46744ZM7.88419 8.46744C7.94846 8.29543 7.92427 8.10289 7.81962 7.9521M7.88419 8.46744L7.81962 7.9521M7.81962 7.9521C7.71495 7.80127 7.54302 7.71131 7.35944 7.71131H5.61521M7.81962 7.9521L5.61521 7.71131M5.61521 7.71131L6.97691 2.24179H10.475L8.51892 5.52373C8.51891 5.52373 8.51891 5.52373 8.51891 5.52374C8.41573 5.69683 8.41349 5.91199 8.51304 6.0872L5.61521 7.71131Z"
          fill="#D28800"
          stroke="#D28800"
          stroke-width="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1308_4993">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.179688 0.271484)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CouncillorsOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9993 16.6553V20.2489"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 20.2484V18.8995C3.75 17.5886 4.67526 16.46 5.96068 16.2029L8.56951 15.6811C8.78514 15.638 9.00907 15.6823 9.19204 15.8043V15.8043C10.8924 16.9379 13.1076 16.9379 14.808 15.8043V15.8043C14.991 15.6823 15.2149 15.638 15.4306 15.6811L18.0394 16.2029C19.3248 16.46 20.25 17.5886 20.25 18.8995V20.2484"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6673 7.78027V10.1651C15.6673 12.1902 14.0257 13.8318 12.0007 13.8318V13.8318C9.97561 13.8318 8.33398 12.1902 8.33398 10.1651V7.78027"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9263 13.2891L14.59 15.9442"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0753 13.2891L9.41163 15.9441"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.58814 6.91979L10.6715 8.94125C11.5084 9.35508 12.4903 9.35508 13.3272 8.94125L17.4106 6.91979C17.7454 6.7561 17.9577 6.41597 17.9577 6.04329C17.9577 5.67061 17.7454 5.33048 17.4106 5.16679L13.3272 3.14533C12.4903 2.7315 11.5084 2.7315 10.6715 3.14533L6.58814 5.16679C6.25333 5.33048 6.04102 5.67061 6.04102 6.04329C6.04102 6.41597 6.25333 6.7561 6.58814 6.91979Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.9583 6.07422V8.45755"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ExperienceIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1929_64141)">
        <circle cx="17" cy="17" r="17" fill="#E1F1FF" />
        <path
          d="M21.75 21.8867L22.75 22.8867L24.25 21.3867"
          stroke="#13599A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="23"
          cy="22"
          r="4"
          stroke="#13599A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 17H8"
          stroke="#13599A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.5 11V9C20.5 7.89543 19.6046 7 18.5 7H15.5C14.3954 7 13.5 7.89543 13.5 9V11"
          stroke="#13599A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 25H11C9.34315 25 8 23.6569 8 22V13.5C8 12.1193 9.11929 11 10.5 11H23.5C24.8807 11 26 12.1193 26 13.5V15"
          stroke="#13599A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const EducationIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1929_64171)">
        <circle cx="17" cy="17" r="17" fill="#FFEDBC" />
        <path
          d="M11.4355 17.6992V21.6232C11.4355 22.5722 11.9105 23.4572 12.6995 23.9822L14.3065 25.0512C16.2075 26.3152 18.6815 26.3152 20.5815 25.0512L22.1885 23.9822C22.9785 23.4572 23.4525 22.5712 23.4525 21.6232V17.6992"
          stroke="#9E6702"
          stroke-width="1.4167"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.1475 9.59475L8.9735 13.0248C7.6755 13.7458 7.6755 15.6117 8.9735 16.3327L15.1475 19.7627C16.5755 20.5557 18.3125 20.5557 19.7415 19.7627L25.9155 16.3327C27.2135 15.6117 27.2135 13.7458 25.9155 13.0248L19.7415 9.59475C18.3125 8.80175 16.5765 8.80175 15.1475 9.59475Z"
          stroke="#9E6702"
          stroke-width="1.419"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const AddIconWithCircle = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#121212" />
      <g clip-path="url(#clip0_1929_64186)">
        <path
          d="M10 5C10.1658 5 10.3247 5.06585 10.4419 5.18306C10.5592 5.30027 10.625 5.45924 10.625 5.625V9.375H14.375C14.5408 9.375 14.6997 9.44085 14.8169 9.55806C14.9342 9.67527 15 9.83424 15 10C15 10.1658 14.9342 10.3247 14.8169 10.4419C14.6997 10.5592 14.5408 10.625 14.375 10.625H10.625V14.375C10.625 14.5408 10.5592 14.6997 10.4419 14.8169C10.3247 14.9342 10.1658 15 10 15C9.83424 15 9.67527 14.9342 9.55806 14.8169C9.44085 14.6997 9.375 14.5408 9.375 14.375V10.625H5.625C5.45924 10.625 5.30027 10.5592 5.18306 10.4419C5.06585 10.3247 5 10.1658 5 10C5 9.83424 5.06585 9.67527 5.18306 9.55806C5.30027 9.44085 5.45924 9.375 5.625 9.375H9.375V5.625C9.375 5.45924 9.44085 5.30027 9.55806 5.18306C9.67527 5.06585 9.83424 5 10 5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1929_64186">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InitiativesIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1929_64197)">
        <circle cx="17" cy="17" r="17" fill="#FFF0E3" />
        <path
          d="M9.49707 26.0041H11.4979"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5024 26.0041H24.5033"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4975 23.5029V26.004"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.5029 23.5029V26.004"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="18.5007"
          cy="15.4997"
          r="4.00167"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9976 20.5012H12.9984"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.6778 15.3222C18.7753 15.4199 18.7751 15.5782 18.6775 15.6757C18.5798 15.7733 18.4216 15.7733 18.3239 15.6757C18.2263 15.5782 18.2261 15.4199 18.3236 15.3222V15.3222C18.4218 15.2253 18.5796 15.2253 18.6778 15.3222"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5007 7.99609V8.99651"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.2093 9.29012L21.502 9.99741"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7923 9.29012L15.4996 9.99741"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5024 15.499H24.003C25.108 15.499 26.0038 16.3948 26.0038 17.4999V21.5015C26.0038 22.6066 25.108 23.5024 24.003 23.5024H9.99717C8.89214 23.5024 7.99634 22.6066 7.99634 21.5015V17.4999C7.99634 16.3948 8.89214 15.499 9.99717 15.499H14.499"
          stroke="#9D4E0C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
export const CloseCircleIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0037 8.00187C12.0037 10.4882 9.98819 12.5037 7.50187 12.5037C5.01556 12.5037 3 10.4882 3 8.00187C3 5.51556 5.01556 3.5 7.50187 3.5C8.69585 3.5 9.84092 3.9743 10.6852 4.81857C11.5294 5.66283 12.0037 6.8079 12.0037 8.00187Z"
        fill="#323232"
      />
      <path
        d="M12.0037 8.00187C12.0037 10.4882 9.98819 12.5037 7.50187 12.5037C5.01556 12.5037 3 10.4882 3 8.00187C3 5.51556 5.01556 3.5 7.50187 3.5C8.69585 3.5 9.84092 3.9743 10.6852 4.81857C11.5294 5.66283 12.0037 6.8079 12.0037 8.00187"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.45972 7.04492L6.54492 8.95972L8.45972 7.04492Z"
        fill="white"
      />
      <path
        d="M8.45972 7.04492L6.54492 8.95972"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.54492 7.04492L8.45972 8.95972L6.54492 7.04492Z"
        fill="white"
      />
      <path
        d="M6.54492 7.04492L8.45972 8.95972"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloseRange = () => {
  return (
    <svg
      fill-rule="evenodd"
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="close-circle"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
    </svg>
  );
};

export const WardsOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.875 19.208C2.875 20.2666 3.73312 21.1247 4.79167 21.1247"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.87467 5.79199V19.2087"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.62533 21.1247H4.79199"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.1247 5.79167C20.1247 4.73312 19.2666 3.875 18.208 3.875"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.1257 8.66699V5.79199"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.79199 3.87467H18.2087"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.875 5.79167C2.875 4.73312 3.73312 3.875 4.79167 3.875"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.14551 17.3516V17.3516C7.3516 17.3516 6.70801 16.708 6.70801 15.9141V15.9141C6.70801 15.1202 7.3516 14.4766 8.14551 14.4766V14.4766C8.93942 14.4766 9.58301 15.1202 9.58301 15.9141V15.9141C9.58301 16.708 8.93942 17.3516 8.14551 17.3516V17.3516Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.70801 7.76823H14.3747"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.70801 11.1217H11.4997"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9375 20.6458V20.2567C12.9407 19.1498 13.8373 18.2532 14.9442 18.25H18.1182C19.2252 18.2532 20.1218 19.1498 20.125 20.2567V20.6458C20.125 20.9105 19.9105 21.125 19.6458 21.125H13.4167C13.152 21.125 12.9375 20.9105 12.9375 20.6458Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6143 13.9295C14.6185 12.872 15.4785 12.0177 16.536 12.0205C17.5936 12.0233 18.449 12.8822 18.4476 13.9397C18.4462 14.9973 17.5885 15.8538 16.531 15.8538C16.0213 15.8538 15.5326 15.6509 15.1729 15.2898C14.8133 14.9287 14.6122 14.4392 14.6143 13.9295V13.9295Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const WardDetailsIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_2522_65022)">
        <circle cx="17" cy="17" r="17" fill="#E9FBEB" />
        <path
          d="M8.13086 23.208C8.13086 24.2666 8.98898 25.1247 10.0475 25.1247"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.13053 9.79199V23.2087"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.8812 25.1247H10.0479"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25.3805 9.79167C25.3805 8.73312 24.5224 7.875 23.4639 7.875"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25.3815 12.667V9.79199"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0479 7.87467H23.4645"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.13086 9.79167C8.13086 8.73312 8.98898 7.875 10.0475 7.875"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4014 21.3516V21.3516C12.6075 21.3516 11.9639 20.708 11.9639 19.9141V19.9141C11.9639 19.1202 12.6075 18.4766 13.4014 18.4766V18.4766C14.1953 18.4766 14.8389 19.1202 14.8389 19.9141V19.9141C14.8389 20.708 14.1953 21.3516 13.4014 21.3516V21.3516Z"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9639 11.7682H19.6305"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9639 15.1217H16.7555"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.1934 24.6458V24.2567C18.1965 23.1498 19.0931 22.2532 20.2001 22.25H23.3741C24.4811 22.2532 25.3777 23.1498 25.3809 24.2567V24.6458C25.3809 24.9105 25.1663 25.125 24.9017 25.125H18.6725C18.4079 25.125 18.1934 24.9105 18.1934 24.6458Z"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.8701 17.9295C19.8744 16.872 20.7344 16.0177 21.7919 16.0205C22.8494 16.0233 23.7049 16.8822 23.7035 17.9397C23.7021 18.9973 22.8444 19.8538 21.7868 19.8538C21.2772 19.8538 20.7885 19.6509 20.4288 19.2898C20.0691 18.9287 19.8681 18.4392 19.8701 17.9295V17.9295Z"
          stroke="#006152"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
export const UserIconFill = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_2522_65089)">
        <circle cx="17" cy="17" r="17" fill="#E1F1FF" />
        <path
          d="M16.9998 21.6553V25.2489"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.75 25.2484V23.8995C8.75 22.5886 9.67526 21.46 10.9607 21.2029L13.5695 20.6811C13.7851 20.638 14.0091 20.6823 14.192 20.8043V20.8043C15.8924 21.9379 18.1076 21.9379 19.808 20.8043V20.8043C19.991 20.6823 20.2149 20.638 20.4306 20.6811L23.0394 21.2029C24.3248 21.46 25.25 22.5886 25.25 23.8995V25.2484"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6668 12.7803V15.1651C20.6668 17.1902 19.0252 18.8318 17.0002 18.8318V18.8318C14.9751 18.8318 13.3335 17.1902 13.3335 15.1651V12.7803"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.9263 18.2891L19.59 20.9442"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.0758 18.2891L14.4121 20.9441"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5886 11.9198L15.6719 13.9413C16.5088 14.3551 17.4908 14.3551 18.3277 13.9413L22.411 11.9198C22.7459 11.7561 22.9582 11.416 22.9582 11.0433C22.9582 10.6706 22.7459 10.3305 22.411 10.1668L18.3277 8.14533C17.4908 7.7315 16.5088 7.7315 15.6719 8.14533L11.5886 10.1668C11.2538 10.3305 11.0415 10.6706 11.0415 11.0433C11.0415 11.416 11.2538 11.7561 11.5886 11.9198Z"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.9583 11.0742V13.4576"
          stroke="#2D6CA7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const InitiativesProjectsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.375 15.375V16.3333C14.375 16.8626 13.9459 17.2917 13.4167 17.2917H9.58333C9.05406 17.2917 8.625 16.8626 8.625 16.3333V15.375"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.875 13.6252V19.2083C2.875 20.2669 3.73312 21.125 4.79167 21.125H18.2083C19.2669 21.125 20.125 20.2669 20.125 19.2083V13.6252C20.125 12.8791 20.0161 12.1369 19.8017 11.4222L17.9473 5.24091C17.7041 4.43019 16.9579 3.87499 16.1114 3.875H6.88856C6.04214 3.875 5.29594 4.4302 5.05273 5.24091L3.19835 11.4222C2.98394 12.1369 2.87501 12.8791 2.875 13.6252Z"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0411 12.4999H2.9585"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8543 6.74992H8.146"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8125 9.62492H7.1875"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

//reports
export const Incidents = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#E1F1FF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.7082 16.0003C23.7082 20.2578 20.2573 23.7087 15.9998 23.7087C11.7423 23.7087 8.2915 20.2578 8.2915 16.0003C8.2915 11.7428 11.7423 8.29199 15.9998 8.29199C20.2573 8.29199 23.7082 11.7428 23.7082 16.0003Z"
        stroke="#13599A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8595 18.4524L15.7178 16.5782V12.5391"
        stroke="#13599A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Response = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#DBF2E4" />
      <path
        d="M14.0833 10.542H9.125V21.8753L12.3125 19.9628H20.4583V14.792"
        stroke="#008000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.875 10.5417H16.9167"
        stroke="#008000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.4576 9.125L21.875 10.5417L20.4576 11.9583"
        stroke="#008000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Resolution = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#FFEFD2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 19.3337C16 17.4927 17.4924 16.0003 19.3333 16.0003C17.4924 16.0003 16 14.5079 16 12.667C16 14.5079 14.5076 16.0003 12.6667 16.0003C14.5076 16.0003 16 17.4927 16 19.3337Z"
        stroke="#744B00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.5 16C23.5 20.1421 20.1421 23.5 16 23.5C11.8579 23.5 8.5 20.1421 8.5 16C8.5 11.8579 11.8579 8.5 16 8.5"
        stroke="#744B00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.8333 12.667C21.8333 11.2863 22.9526 10.167 24.3333 10.167C22.9526 10.167 21.8333 9.0477 21.8333 7.66699C21.8333 9.0477 20.714 10.167 19.3333 10.167C20.714 10.167 21.8333 11.2863 21.8333 12.667Z"
        stroke="#744B00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RedScale = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6257 8.5H14.9999V4.12578"
        stroke="#BF2B17"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 8.5L8.87422 2.37422L5.37422 5.87422L1 1.5"
        stroke="#BF2B17"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const GreenScale = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6257 4.5H14.9999V8.87422"
        stroke="#008000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 4.5L8.87422 10.6258L5.37422 7.12578L1 11.5"
        stroke="#008000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UpArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#DBF2E4" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#B3E2C5" />
      <path d="M8 5L4 10H12L8 5Z" fill="#008000" />
    </svg>
  );
};

export const DownArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#F9EAE8" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#EBBDB7" />
      <path d="M8 11L4 6H12L8 11Z" fill="#BF2B17" />
    </svg>
  );
};

export const CalenderTermIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99996 2V3.33333"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66671 2V3.33333"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 6.00033H12.6667"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6667 6.66699V4.66699C12.6667 3.56233 11.7713 2.66699 10.6667 2.66699H4C2.89533 2.66699 2 3.56233 2 4.66699V10.667C2 11.7717 2.89533 12.667 4 12.667H6.66667"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5953 10.6553V11.8273L12.5167 12.3893"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6666 14.667C10.01 14.667 8.66663 13.3243 8.66663 11.667C8.66663 10.0443 10.0466 8.66499 11.6693 8.66699C13.3253 8.66833 14.6666 10.011 14.6666 11.667C14.6666 13.3237 13.324 14.667 11.6666 14.667"
        stroke="#121212"
        stroke-width="1.5"
      />
    </svg>
  );
};

export const InitiativesArticlesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.375 15.375V16.3333C14.375 16.8626 13.9459 17.2917 13.4167 17.2917H9.58333C9.05406 17.2917 8.625 16.8626 8.625 16.3333V15.375"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.875 13.6252V19.2083C2.875 20.2669 3.73312 21.125 4.79167 21.125H18.2083C19.2669 21.125 20.125 20.2669 20.125 19.2083V13.6252C20.125 12.8791 20.0161 12.1369 19.8017 11.4222L17.9473 5.24091C17.7041 4.43019 16.9579 3.87499 16.1114 3.875H6.88856C6.04214 3.875 5.29594 4.4302 5.05273 5.24091L3.19835 11.4222C2.98394 12.1369 2.87501 12.8791 2.875 13.6252Z"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0406 12.4997H2.95801"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8538 6.74967H8.14551"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8125 9.62467H7.1875"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ReportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5791 12.0528H13.737"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5791 16.5264H11.5002"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.4211 20.9996H4.68421C3.75368 20.9996 3 20.2433 3 19.3095V7.47912C3 6.54536 3.75368 5.78906 4.68421 5.78906H6.57895M17.3158 10.0142V7.47912C17.3158 6.54536 16.5621 5.78906 15.6316 5.78906H13.7368"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.5791 5.78947L7.74226 4.33553C7.91226 4.12347 8.16905 4 8.44105 4H11.8759C12.1479 4 12.4047 4.12347 12.5747 4.33553L13.737 5.78947V5.78947V6.68421C13.737 7.17811 13.3362 7.57895 12.8423 7.57895H7.47384C6.97994 7.57895 6.5791 7.17811 6.5791 6.68421V5.78947V5.78947H6.5791Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2959 16.6287V14.9629"
        stroke="#121212"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2955 17.9668C17.234 17.9668 17.1842 18.0167 17.1846 18.0782C17.1846 18.1396 17.2345 18.1895 17.2959 18.1895C17.3574 18.1895 17.4073 18.1396 17.4073 18.0782C17.4073 18.0167 17.3574 17.9668 17.2955 17.9668"
        stroke="#121212"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1995 12.6283L21.6109 18.5986C22.0073 19.2925 21.5062 20.1561 20.7071 20.1561H13.8844C13.0849 20.1561 12.5838 19.2925 12.9807 18.5986L16.392 12.6283C16.7916 11.9286 17.8 11.9286 18.1995 12.6283Z"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6478 7.73763C17.6478 7.35858 17.4973 6.99525 17.2292 6.72716C16.9616 6.45954 16.5983 6.30906 16.2192 6.30906H14.5821C14.3635 6.30906 14.173 6.16001 14.1197 5.94811L14.0045 5.4862C13.8454 4.85049 13.274 4.4043 12.6183 4.4043H9.34398C8.68826 4.4043 8.11684 4.85049 7.95779 5.4862L7.84255 5.94811C7.78921 6.16001 7.59874 6.30906 7.38017 6.30906H5.74302C5.36398 6.30906 5.00064 6.45954 4.73302 6.72716C4.46493 6.99525 4.31445 7.35858 4.31445 7.73763C4.31445 9.38668 4.31445 12.7543 4.31445 14.4033C4.31445 14.7824 4.46493 15.1457 4.73302 15.4133C5.00064 15.6814 5.36398 15.8319 5.74302 15.8319H16.2192C16.5983 15.8319 16.9616 15.6814 17.2292 15.4133C17.4973 15.1457 17.6478 14.7824 17.6478 14.4033V7.73763ZM10.9811 7.26049C9.1416 7.26049 7.64779 8.7543 7.64779 10.5938C7.64779 12.4333 9.1416 13.9272 10.9811 13.9272C12.8206 13.9272 14.3145 12.4333 14.3145 10.5938C14.3145 8.7543 12.8206 7.26049 10.9811 7.26049ZM10.9811 8.21287C12.2954 8.21287 13.3621 9.27954 13.3621 10.5938C13.3621 11.9081 12.2954 12.9748 10.9811 12.9748C9.66683 12.9748 8.60017 11.9081 8.60017 10.5938C8.60017 9.27954 9.66683 8.21287 10.9811 8.21287Z"
        fill="white"
      />
    </svg>
  );
};
export const ActiveDirectoryIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect
        y="0.0859375"
        width="24"
        height="23.8278"
        fill="url(#pattern0_3451_38926)"
      />
      <defs>
        <pattern
          id="pattern0_3451_38926"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlink:href="#image0_3451_38926"
            transform="scale(0.00239234 0.00240964)"
          />
        </pattern>
        <image
          id="image0_3451_38926"
          width="2500"
          height="415"
          preserveAspectRatio="none"
          xlink:href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const ArticleEmptyIcon = () => {
  return (
    <svg
      width="44"
      height="37"
      viewBox="0 0 44 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="26.0004" cy="16.5365" r="12.3636" fill="#EAECF0" />
      <circle cx="13.0186" cy="7.26273" r="1.23636" fill="#DFDFE3" />
      <circle cx="39.6006" cy="23.646" r="0.927273" fill="#F2F4F7" />
      <circle cx="12.8628" cy="25.5005" r="1.54545" fill="#F2F4F7" />
      <circle
        cx="41.4551"
        cy="10.0445"
        r="1.54545"
        fill="#C6C6CF"
        fill-opacity="0.5"
      />
      <circle cx="38.5188" cy="5.87283" r="1.08182" fill="#F2F4F7" />
      <g filter="url(#filter0_dd_1929_64036)">
        <path
          d="M25.7089 19.4552L17.6028 23.2351C17.2709 23.3899 16.8763 23.2463 16.7216 22.9144L11.2472 11.1745C11.0924 10.8426 11.236 10.4481 11.5679 10.2933L18.1438 7.22687L21.2687 8.36423L26.0296 18.574C26.1844 18.9059 26.0408 19.3004 25.7089 19.4552Z"
          fill="url(#paint0_linear_1929_64036)"
          stroke="#C6C6CF"
          stroke-width="0.3"
        />
        <path
          d="M18.1367 7.06445L21.3784 8.24432L19.1676 9.27521L18.1367 7.06445Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter1_dd_1929_64036)">
        <path
          d="M21.5416 20.6061H30.4857C30.9348 20.6061 31.2988 20.2421 31.2988 19.793V8.46567L28.8595 6.02637H21.5416C21.0926 6.02637 20.7285 6.3904 20.7285 6.83947V19.793C20.7285 20.2421 21.0926 20.6061 21.5416 20.6061Z"
          fill="url(#paint1_linear_1929_64036)"
        />
        <path
          d="M28.8589 6.02637L31.2982 8.46567H28.8589V6.02637Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter2_dd_1929_64036)">
        <path
          d="M26.1417 19.5837L34.2478 23.3637C34.6548 23.5534 35.1385 23.3774 35.3283 22.9704L40.1155 12.7043L38.9356 9.46268L32.3033 6.37C31.8963 6.18022 31.4126 6.3563 31.2228 6.76329L25.7484 18.5032C25.5586 18.9102 25.7347 19.3939 26.1417 19.5837Z"
          fill="url(#paint2_linear_1929_64036)"
        />
        <path
          d="M38.9355 9.46289L40.1154 12.7045L37.9047 11.6736L38.9355 9.46289Z"
          fill="#D0D5DD"
        />
      </g>
      <rect
        x="21.6738"
        y="17.7725"
        width="8.65455"
        height="8.65455"
        rx="4.32727"
        fill="url(#paint3_linear_1929_64036)"
      />
      <g clip-path="url(#clip0_1929_64036)">
        <path
          d="M26.7221 22.821L26.0009 22.0998M26.0009 22.0998L25.2797 22.821M26.0009 22.0998V23.7226M27.5136 23.252C27.6895 23.1561 27.8284 23.0044 27.9085 22.8208C27.9885 22.6372 28.0052 22.4322 27.9558 22.2381C27.9064 22.044 27.7937 21.8718 27.6356 21.7489C27.4776 21.6259 27.283 21.559 27.0827 21.5589H26.8555C26.801 21.3478 26.6992 21.1519 26.558 20.9857C26.4168 20.8196 26.2398 20.6877 26.0402 20.5998C25.8407 20.512 25.6238 20.4705 25.4059 20.4785C25.188 20.4865 24.9748 20.5439 24.7823 20.6462C24.5897 20.7485 24.4229 20.8931 24.2943 21.0691C24.1657 21.2452 24.0786 21.4481 24.0397 21.6627C24.0008 21.8772 24.0111 22.0978 24.0697 22.3078C24.1283 22.5178 24.2338 22.7117 24.3782 22.8751"
          stroke="white"
          stroke-width="0.360606"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <g clip-path="url(#clip1_1929_64036)">
        <path
          d="M37.6626 8.99707H17.7708C17.5025 8.99724 17.2452 9.10392 17.0554 9.29368C16.8656 9.48344 16.759 9.74076 16.7588 10.0091V28.26C16.759 28.5284 16.8656 28.7857 17.0554 28.9755C17.2452 29.1652 17.5025 29.2719 17.7708 29.2721H37.6626C37.931 29.2719 38.1884 29.1653 38.3781 28.9755C38.5679 28.7857 38.6746 28.5284 38.6748 28.26V10.0091C38.6746 9.74075 38.5679 9.48341 38.3781 9.29364C38.1884 9.10388 37.931 8.99721 37.6626 8.99707Z"
          fill="#9C9CA3"
        />
        <path
          d="M36.3525 22.929H19.0799C18.521 22.929 18.0679 22.4759 18.0679 21.917V5.79135C18.0679 5.23244 18.521 4.7793 19.0799 4.7793H36.3525C36.9114 4.7793 37.3646 5.23244 37.3646 5.79135V21.917C37.3646 22.4759 36.9114 22.929 36.3525 22.929Z"
          fill="#C6C6CF"
        />
        <path
          d="M18.3883 22.2373V6.11178C18.3883 5.55287 18.8414 5.09972 19.4004 5.09972H36.6729C36.8704 5.09972 37.0539 5.15709 37.2095 5.25481C37.0306 4.9695 36.7141 4.7793 36.3525 4.7793H19.0799C18.521 4.7793 18.0679 5.23244 18.0679 5.79135V21.917C18.0679 22.2787 18.2581 22.595 18.5434 22.774C18.4457 22.6183 18.3883 22.4348 18.3883 22.2374V22.2373Z"
          fill="url(#paint4_linear_1929_64036)"
        />
        <path
          d="M34.2281 8.18652H21.2061V8.92864H34.2281V8.18652ZM34.2281 11.0202H21.2061V11.7623H34.2281V11.0202ZM34.2281 13.8544H21.2061V14.5965H34.2281V13.8544ZM34.2281 16.6881H21.2061V17.4303H34.2281V16.6881Z"
          fill="white"
        />
        <path
          d="M22.7573 14.2949L26.0296 17.5673H22.7573V14.2949Z"
          fill="url(#paint5_linear_1929_64036)"
        />
        <path
          d="M38.6743 17.8359V10.3068L37.3647 8.99707V17.8357H38.6743V17.8359Z"
          fill="#9C9CA3"
        />
        <path
          d="M39.2067 17.5337C39.7139 17.5337 40.105 17.9787 40.0422 18.4802L40.0403 18.4936L38.6293 28.4816C38.5706 28.8971 38.2151 29.2059 37.7955 29.2059H17.6378C17.2182 29.2059 16.8627 28.8971 16.804 28.4816L14.8972 14.9854C14.8972 14.9854 14.8972 14.9854 14.8972 14.9854C14.8256 14.4784 15.219 14.0255 15.731 14.0255H21.9561C22.3757 14.0255 22.7313 14.3343 22.7899 14.7496L22.7899 14.7496L23.0398 16.517C23.0398 16.517 23.0398 16.517 23.0398 16.5171C23.1222 17.1003 23.6214 17.5337 24.2103 17.5337H39.2067Z"
          fill="url(#paint6_linear_1929_64036)"
          stroke="#C6C6CF"
          stroke-width="0.34"
        />
        <path
          d="M35.2094 24.9208H20.2241C20.1419 24.9207 20.0626 24.8907 20.001 24.8364C19.9394 24.7821 19.8997 24.7072 19.8893 24.6257L19.7018 23.1413C19.6959 23.0938 19.7001 23.0456 19.7142 22.9999C19.7283 22.9541 19.7519 22.9119 19.7836 22.876C19.8153 22.8401 19.8542 22.8114 19.8978 22.7917C19.9414 22.772 19.9887 22.7617 20.0366 22.7617H35.3969C35.4447 22.7617 35.492 22.772 35.5357 22.7917C35.5793 22.8114 35.6182 22.8401 35.6499 22.876C35.6815 22.9119 35.7052 22.9541 35.7193 22.9999C35.7334 23.0456 35.7376 23.0938 35.7316 23.1413L35.5441 24.6257C35.5338 24.7072 35.4941 24.7821 35.4325 24.8364C35.3708 24.8907 35.2915 24.9207 35.2094 24.9208Z"
          fill="#686869"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1929_64036"
          x="0.68576"
          y="-0.957706"
          width="35.9053"
          height="37.8443"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1929_64036"
          />
          <feOffset dy="1.23636" />
          <feGaussianBlur stdDeviation="0.618182" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1929_64036"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1929_64036"
          />
          <feOffset dy="3.09091" />
          <feGaussianBlur stdDeviation="5.35" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1929_64036"
            result="effect2_dropShadow_1929_64036"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1929_64036"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_1929_64036"
          x="17.6376"
          y="6.02637"
          width="16.7521"
          height="20.7619"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1929_64036"
          />
          <feOffset dy="1.23636" />
          <feGaussianBlur stdDeviation="0.618182" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1929_64036"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1929_64036"
          />
          <feOffset dy="3.09091" />
          <feGaussianBlur stdDeviation="1.85455" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1929_64036"
            result="effect2_dropShadow_1929_64036"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1929_64036"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_1929_64036"
          x="22.3139"
          y="6.02637"
          width="21.9235"
          height="23.8625"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1929_64036"
          />
          <feOffset dy="1.23636" />
          <feGaussianBlur stdDeviation="0.618182" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1929_64036"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.618182"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1929_64036"
          />
          <feOffset dy="3.09091" />
          <feGaussianBlur stdDeviation="1.85455" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1929_64036"
            result="effect2_dropShadow_1929_64036"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1929_64036"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1929_64036"
          x1="17.1899"
          y1="23.4027"
          x2="10.1558"
          y2="16.251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1929_64036"
          x1="21.0966"
          y1="20.4335"
          x2="20.1672"
          y2="7.14112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1929_64036"
          x1="25.8113"
          y1="19.2392"
          x2="30.5866"
          y2="6.79947"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1929_64036"
          x1="26.0011"
          y1="13.4452"
          x2="17.3466"
          y2="22.0997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8960" />
          <stop offset="1" stop-color="#FF62A5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1929_64036"
          x1="28.3097"
          y1="14.4465"
          x2="15.5106"
          y2="1.64729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1929_64036"
          x1="24.9193"
          y1="18.0923"
          x2="20.964"
          y2="14.1371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C2CECE" stop-opacity="0" />
          <stop offset="0.179" stop-color="#AFBCBC" stop-opacity="0.179" />
          <stop offset="1" stop-color="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1929_64036"
          x1="27.002"
          y1="17.502"
          x2="27.4687"
          y2="29.3759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.927" stop-color="#E4E4E4" />
        </linearGradient>
        <clipPath id="clip0_1929_64036">
          <rect
            width="4.32727"
            height="4.32727"
            fill="white"
            transform="translate(23.8374 19.9365)"
          />
        </clipPath>
        <clipPath id="clip1_1929_64036">
          <rect
            width="25.5"
            height="25.5"
            fill="white"
            transform="translate(14.7178 4.32812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailSearchIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill="#FEBF4B" />
      <circle
        cx="15.8439"
        cy="15.8439"
        r="5.99237"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0117 20.3242L22.3611 22.6675"
        stroke="#121212"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EyeIconPassword = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3810_27482)">
        <path
          d="M12 4.84668C7.41454 4.84668 3.25621 7.35543 0.187788 11.4303C-0.0625959 11.7641 -0.0625959 12.2305 0.187788 12.5644C3.25621 16.6442 7.41454 19.1529 12 19.1529C16.5855 19.1529 20.7438 16.6442 23.8122 12.5693C24.0626 12.2354 24.0626 11.769 23.8122 11.4352C20.7438 7.35543 16.5855 4.84668 12 4.84668ZM12.3289 17.0369C9.28506 17.2284 6.7714 14.7196 6.96287 11.6709C7.11998 9.1572 9.15741 7.11977 11.6711 6.96267C14.7149 6.7712 17.2286 9.27994 17.0371 12.3287C16.8751 14.8375 14.8377 16.8749 12.3289 17.0369ZM12.1767 14.7098C10.537 14.8129 9.18196 13.4628 9.28997 11.8231C9.37343 10.468 10.4732 9.37322 11.8282 9.28485C13.4679 9.18175 14.823 10.5319 14.7149 12.1716C14.6266 13.5316 13.5268 14.6264 12.1767 14.7098Z"
          fill="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_3810_27482">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EyeIconOpenPassword = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4505_37304)">
        <path
          d="M1.281 0.218887C0.9885 -0.0736133 0.513 -0.0736133 0.2205 0.218887C-0.072 0.511387 -0.072 0.986887 0.2205 1.27939L5.5395 6.59989C3.744 7.75939 1.95 9.37339 0.18 11.5049C-0.06 11.7749 -0.06 12.1799 0.18 12.4649C4.05 17.1299 8.04 19.4999 12 19.4999C13.701 19.4999 15.402 19.0334 17.103 18.1634L22.7205 23.7809C22.866 23.9264 23.058 23.9999 23.25 23.9999C23.442 23.9999 23.634 23.9264 23.781 23.7809C24.0735 23.4884 24.0735 23.0129 23.781 22.7204L1.281 0.218887ZM12 16.4999C9.51 16.4999 7.5 14.4899 7.5 11.9999C7.5 11.0279 7.818 10.1339 8.34 9.40039L9.426 10.4864C9.159 10.9319 9 11.4449 9 11.9999C9 13.6499 10.35 14.9999 12 14.9999C12.555 14.9999 13.068 14.8409 13.5135 14.5739L14.5995 15.6599C13.866 16.1819 12.972 16.4999 12 16.4999ZM10.845 7.66489L8.34 5.15989C13.515 3.28489 18.75 5.39989 23.82 11.5049C24.06 11.7749 24.06 12.1799 23.82 12.4649C22.47 14.0999 21.09 15.4499 19.71 16.5299L16.335 13.1549C16.44 12.7949 16.5 12.4049 16.5 11.9999C16.5 9.50989 14.49 7.49989 12 7.49989C11.595 7.49989 11.205 7.55989 10.845 7.66489Z"
          fill="#1E1F21"
        />
      </g>
      <defs>
        <clipPath id="clip0_4505_37304">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UserHeadIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6663 17.5C16.6663 16.337 16.6663 15.7555 16.5228 15.2824C16.1996 14.217 15.366 13.3834 14.3006 13.0602C13.8275 12.9167 13.246 12.9167 12.083 12.9167H7.91635C6.75337 12.9167 6.17189 12.9167 5.69872 13.0602C4.63339 13.3834 3.79971 14.217 3.47654 15.2824C3.33301 15.7555 3.33301 16.337 3.33301 17.5M13.7497 6.25C13.7497 8.32107 12.0707 10 9.99968 10C7.92861 10 6.24968 8.32107 6.24968 6.25C6.24968 4.17893 7.92861 2.5 9.99968 2.5C12.0707 2.5 13.7497 4.17893 13.7497 6.25Z"
        stroke="#475467"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UploadAttachments = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4664_39420)">
        <rect
          x="2"
          y="1"
          width="40"
          height="40"
          rx="8"
          fill="white"
          shape-rendering="crispEdges"
        />
        <rect
          x="2.5"
          y="1.5"
          width="39"
          height="39"
          rx="7.5"
          stroke="#D0D5E0"
          stroke-linecap="round"
          shape-rendering="crispEdges"
        />
        <path
          d="M18.6665 24.3333L21.9998 21M21.9998 21L25.3332 24.3333M21.9998 21V28.5M28.6665 24.9524C29.6844 24.1117 30.3332 22.8399 30.3332 21.4167C30.3332 18.8854 28.2811 16.8333 25.7498 16.8333C25.5677 16.8333 25.3974 16.7383 25.3049 16.5814C24.2182 14.7374 22.2119 13.5 19.9165 13.5C16.4647 13.5 13.6665 16.2982 13.6665 19.75C13.6665 21.4718 14.3627 23.0309 15.489 24.1613"
          stroke="#475467"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4664_39420"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4664_39420"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4664_39420"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
